const LOBBY_PAGE_TITLES: Record<string, string> = {
  '/': 'Home',
  '/marketplace': 'Home',
  '/overview': 'Overview',
  '/visualizer': 'Visualizer',
  '/customers': 'Customers',
  '/budget': 'Budget',
  '/wallet': 'Wallet',
  '/settings': 'Settings',
  '/alerts': 'Alerts',
  '/campaigns': 'Campaigns',
  '/creatives': 'Creatives',
  '/properties': 'Properties',
  '/developers': 'Developers',
  '/connectors': 'Connectors',
  '/activity': 'Activity',
  '/chat': 'Chat',
  '/commands': 'Commands',
  '/scheduled': 'Scheduled',
  '/subagents': 'Subagents',
  '/usage': 'Usage',
  '/health': 'Health',
  '/videos': 'Creatives',
  '/work': 'Work',
  '/admin': 'Admin',
}

const CHANNEL_TITLES: Record<string, string> = {
  search: 'Search',
  social: 'Social',
  tv: 'TV / CTV',
  programmatic: 'Programmatic',
  audio: 'Audio',
  retail: 'Retail Media',
}

function humanizeSegment(segment: string): string {
  return segment
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

/** Derive a lobby shell header title from the current pathname. */
export function resolveLobbyPageTitle(pathname: string | null | undefined): string {
  const path = pathname ?? ''
  const exact = LOBBY_PAGE_TITLES[path]
  if (exact) return exact

  const channelMatch = path.match(/^\/channels\/([^/]+)/)
  if (channelMatch) {
    const key = channelMatch[1]
    return CHANNEL_TITLES[key] ?? humanizeSegment(key)
  }

  const segments = path.split('/').filter(Boolean)
  if (segments.length === 0) return 'Home'

  const root = `/${segments[0]}`
  const rootTitle = LOBBY_PAGE_TITLES[root]
  if (rootTitle && segments.length === 1) return rootTitle

  if (rootTitle && segments.length > 1) {
    const last = segments[segments.length - 1]
    // Don't try to humanize UUIDs / opaque ids — fall back to the root title
    // (the page itself can override via LobbyHeaderMeta with the actual name).
    if (isOpaqueId(last)) return rootTitle
    return humanizeSegment(last)
  }

  return humanizeSegment(segments[0])
}

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
function isOpaqueId(segment: string): boolean {
  if (UUID_RE.test(segment)) return true
  // Long hex-ish blobs without word breaks are almost certainly ids, not labels.
  if (segment.length > 16 && /^[0-9a-f-]+$/i.test(segment)) return true
  return false
}
